export default __webpack_public_path__ + "static/media/7B1_rio_grande_blankets_scan001.7764c061.png";